<!-- TaxpayerFormModal.vue -->
<template>
  <div class="modal fade" id="taxpayerFormModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            <i class="mdi mdi-account-plus me-2"></i>
            {{ isEditing ? 'Edit Taxpayer' : 'Add New Taxpayer' }}
          </h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submitForm">
            <!-- Basic Information -->
            <div class="card border mb-4">
              <div class="card-header bg-primary text-white">
                <h6 class="mb-0 text-white">
                  <i class="mdi mdi-account me-2"></i>
                  Basic Information
                </h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Full Name <span class="text-danger">*</span></label>
                    <input v-model="form.name" type="text" class="form-control" required>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Taxpayer Type <span class="text-danger">*</span></label>
                    <select v-model="form.type" class="form-select" required>
                      <option value="INDIVIDUAL">Individual</option>
                      <option value="BUSINESS">Business</option>
                      <option value="ORGANIZATION">Organization</option>
                    </select>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label">National ID <span class="text-danger">*</span></label>
                    <input v-model="form.nationalId" type="text" class="form-control" required>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label">KRA PIN <span class="text-danger">*</span></label>
                    <input v-model="form.kraPin" type="text" class="form-control" required>
                  </div>
                </div>

                <div v-if="form.type !== 'INDIVIDUAL'" class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Business/Organization Name</label>
                    <input v-model="form.businessName" type="text" class="form-control">
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Business Registration Number</label>
                    <input v-model="form.businessRegNo" type="text" class="form-control">
                  </div>
                </div>
              </div>
            </div>

            <!-- Contact Information -->
            <div class="card border mb-4">
              <div class="card-header bg-info text-white">
                <h6 class="mb-0 text-white">
                  <i class="mdi mdi-phone me-2"></i>
                  Contact Information
                </h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Phone Number <span class="text-danger">*</span></label>
                    <input v-model="form.phone" type="tel" class="form-control" required>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Email Address <span class="text-danger">*</span></label>
                    <input v-model="form.email" type="email" class="form-control" required>
                  </div>
                </div>
              </div>
            </div>

            <!-- Operating Locations -->
            <div class="card border mb-4">
              <div class="card-header bg-success text-white">
                <h6 class="mb-0 text-white">
                  <i class="mdi mdi-map-marker me-2"></i>
                  Operating Locations
                </h6>
              </div>
              <div class="card-body">
                <div class="mb-3">
                  <div class="d-flex align-items-center mb-2">
                    <input v-model="newLocation" type="text" class="form-control me-2"
                           placeholder="Enter location (e.g., Nairobi - CBD)">
                    <button @click="addLocation" type="button" class="btn btn-primary">
                      <i class="mdi mdi-plus"></i>
                    </button>
                  </div>
                  <small class="text-muted">Format: County - Area/Ward</small>
                </div>

                <div v-if="form.locations.length > 0">
                  <div v-for="(location, index) in form.locations" :key="index"
                       class="d-flex align-items-center justify-content-between border rounded p-2 mb-2">
                    <span>{{ location }}</span>
                    <button @click="removeLocation(index)" type="button" class="btn btn-sm btn-outline-danger">
                      <i class="mdi mdi-delete"></i>
                    </button>
                  </div>
                </div>
                <div v-else class="text-muted text-center py-3">
                  No locations added yet
                </div>
              </div>
            </div>

            <!-- Revenue Streams -->
            <div class="card border mb-4">
              <div class="card-header bg-warning text-dark">
                <h6 class="mb-0">
                  <i class="mdi mdi-currency-usd me-2"></i>
                  Revenue Streams
                </h6>
              </div>
              <div class="card-body">
                <div class="mb-3">
                  <div class="row">
                    <div class="col-md-4 mb-2">
                      <select v-model="newStream.type" class="form-select">
                        <option value="">Select Stream Type</option>
                        <option value="SBP">Single Business Permit</option>
                        <option value="Liquor License">Liquor License</option>
                        <option value="Land Rates">Land Rates</option>
                        <option value="Market Fees">Market Fees</option>
                        <option value="Parking Fees">Parking Fees</option>
                        <option value="Building Plan">Building Plan Approval</option>
                        <option value="Billboard">Billboard Advertising</option>
                        <option value="Fire Certificate">Fire Certificate</option>
                      </select>
                    </div>
                    <div class="col-md-3 mb-2">
                      <input v-model="newStream.location" type="text" class="form-control"
                             placeholder="Location">
                    </div>
                    <div class="col-md-3 mb-2">
                      <input v-model="newStream.amount" type="number" class="form-control"
                             placeholder="Monthly Amount">
                    </div>
                    <div class="col-md-2 mb-2">
                      <button @click="addRevenueStream" type="button" class="btn btn-primary w-100">
                        <i class="mdi mdi-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div v-if="form.revenueStreams.length > 0">
                  <div v-for="(stream, index) in form.revenueStreams" :key="index"
                       class="border rounded p-3 mb-2">
                    <div class="d-flex justify-content-between align-items-start">
                      <div>
                        <span class="badge bg-primary mb-1">{{ stream.type }}</span>
                        <div class="text-muted">
                          <i class="mdi mdi-map-marker me-1"></i>
                          {{ stream.location }}
                        </div>
                      </div>
                      <div class="text-end">
                        <div class="fw-bold">{{ formatPrice(stream.amount) }}</div>
                        <button @click="removeRevenueStream(index)" type="button"
                                class="btn btn-sm btn-outline-danger mt-1">
                          <i class="mdi mdi-delete"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="text-muted text-center py-3">
                  No revenue streams added yet
                </div>
              </div>
            </div>

            <!-- Status -->
            <div class="card border">
              <div class="card-header bg-secondary text-white">
                <h6 class="mb-0 text-white">
                  <i class="mdi mdi-check-circle me-2"></i>
                  Status Information
                </h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Status</label>
                    <select v-model="form.status" class="form-select">
                      <option value="ACTIVE">Active</option>
                      <option value="INACTIVE">Inactive</option>
                      <option value="SUSPENDED">Suspended</option>
                    </select>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label">Calculated Monthly Revenue</label>
                    <input :value="formatPrice(calculateMonthlyRevenue())"
                           type="text" class="form-control" readonly>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Cancel
          </button>
          <button @click="submitForm" type="button" class="btn btn-primary" :disabled="!isFormValid">
            <i class="mdi mdi-content-save me-1"></i>
            {{ isEditing ? 'Update' : 'Save' }} Taxpayer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TaxpayerFormModal",
  props: {
    taxpayer: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: '',
        businessName: '',
        nationalId: '',
        businessRegNo: '',
        kraPin: '',
        phone: '',
        email: '',
        type: 'INDIVIDUAL',
        status: 'ACTIVE',
        locations: [],
        revenueStreams: []
      },
      newLocation: '',
      newStream: {
        type: '',
        location: '',
        amount: ''
      }
    }
  },
  computed: {
    isFormValid() {
      return this.form.name.trim() !== '' &&
          this.form.nationalId.trim() !== '' &&
          this.form.kraPin.trim() !== '' &&
          this.form.phone.trim() !== '' &&
          this.form.email.trim() !== '';
    }
  },
  watch: {
    taxpayer: {
      handler(newValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          this.form = { ...newValue };
          if (!this.form.locations) this.form.locations = [];
          if (!this.form.revenueStreams) this.form.revenueStreams = [];
        } else {
          this.resetForm();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0
      }).format(value || 0);
    },

    addLocation() {
      if (this.newLocation.trim()) {
        this.form.locations.push(this.newLocation.trim());
        this.newLocation = '';
      }
    },

    removeLocation(index) {
      this.form.locations.splice(index, 1);
    },

    addRevenueStream() {
      if (this.newStream.type && this.newStream.location && this.newStream.amount) {
        this.form.revenueStreams.push({
          type: this.newStream.type,
          location: this.newStream.location,
          amount: parseFloat(this.newStream.amount)
        });
        this.newStream = { type: '', location: '', amount: '' };
      }
    },

    removeRevenueStream(index) {
      this.form.revenueStreams.splice(index, 1);
    },

    calculateMonthlyRevenue() {
      return this.form.revenueStreams.reduce((total, stream) => total + (stream.amount || 0), 0);
    },

    submitForm() {
      if (this.isFormValid) {
        const taxpayerData = {
          ...this.form,
          monthlyRevenue: this.calculateMonthlyRevenue()
        };

        this.$emit('save-taxpayer', taxpayerData);
      }
    },

    resetForm() {
      this.form = {
        name: '',
        businessName: '',
        nationalId: '',
        businessRegNo: '',
        kraPin: '',
        phone: '',
        email: '',
        type: 'INDIVIDUAL',
        status: 'ACTIVE',
        locations: [],
        revenueStreams: []
      };
      this.newLocation = '';
      this.newStream = { type: '', location: '', amount: '' };
    }
  }
}
</script>

<style scoped>
.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.card-header.bg-primary h6,
.card-header.bg-info h6,
.card-header.bg-success h6,
.card-header.bg-secondary h6 {
  color: white !important;
}

.border {
  border-color: #dee2e6 !important;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}
</style>